import styled from 'styled-components';
import color from '../../../../config/colors.json';

export const SpecialProjectContent = styled.div`

    .card-thank{
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 48.79px 0px 43.21px 0px;
        margin: -8px 0px 28px 0px

        .content-header{
            display: flex;
            justify-content: center;
            color: ${color.lightGrey7};
            font-size: 18px;
            font-family: 'Poppins', sans-serif;
        }
    
        .content-body{
            display: flex;
            justify-content: center;
            margin: 0px;
        }
    }

    .btn-primary{
        color: ${color.light};
        font-size: 40px;
        box-shadow: 0px 2px 3px #00000029;
        border-radius: 2px;
        border: none;
        height: 40px;
    }
`;
